<template>
  <div>
    <div class="cs-rgist-main">
      <div class="tab-design cs">
        <ul>
          <li>
            <router-link
              :to="{ name: 'CsRegist' }"
              class="router-link-deactive"
              >{{ $t("inquiry.submit") }}</router-link
            >
          </li>
          <li>
            <router-link :to="{ name: 'CsList' }" class="router-link-active">{{
              $t("inquiry.inquiryList")
            }}</router-link>
          </li>
        </ul>
      </div>
    </div>
    <!-- CS LIST//S -->
    <div class="board-list">
      <ul>
        <li v-for="(cs, index) in csList" :key="index">
          <router-link :to="`/cs/list/${cs.id}`" class="well">
            <h4>
              <strong>[{{ cs.type }}]</strong> {{ cs.title }}
            </h4>
            <div class="clearfix">
              <span class="pull-left date">{{ cs.date }}</span>
              <span v-if="cs.condition" class="pull-right date">{{
                $t("inquiry.CompletedAnswer")
              }}</span>
              <span v-if="!cs.condition" class="pull-right txt-blue">{{
                $t("inquiry.Pending")
              }}</span>
            </div>
          </router-link>
        </li>
        <li v-if="csList.length == 0">
          <router-link class="well" to="">
            <h4>{{ $t("inquiry.noContents") }}</h4>
          </router-link>
        </li>
      </ul>
      <router-link :to="{ name: 'CsRegist' }" class="cs-regist-link">
        {{ $t("inquiry.header") }}
      </router-link>
    </div>
    <!-- CS LIST//E -->
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import Moment from "moment";
import Api from "@/common/Api";
export default {
  mounted() {
    this.getQnaList();
  },
  methods: {
    getQnaList() {
      const params = {
        type: 5,
        page: this.pagination.currentPage,
        count: this.paginationPer,
      };
      Api.Board.getItems(params)
        .then((response) => {
          const pagination = response.pagination;
          const data = response.body;
          this.paginationTotal = pagination.total;
          _.map(data, (row, idx) => {
            this.csList.push({
              id: row.id,
              title: row.title,
              type: this.cateString(row.category),
              date: Moment(row.regDate).format("YYYY-MM-DD"),
              condition: row.answerStatus,
            });
          });
          //this.csList = [];
        })
        .catch((err) => {});
    },
    cateString(cate) {
      switch (cate) {
        case "1":
          return this.$t("inquiry.menu[1]");
          break;
        case "2":
          return this.$t("inquiry.menu[2]");
          break;
        case "3":
          return this.$t("inquiry.menu[3]");
          break;
        case "4":
          return this.$t("inquiry.menu[4]");
          break;
        case "5":
          return this.$t("inquiry.menu[5]");
          break;
        case "6":
          return this.$t("inquiry.menu[6]");
          break;
        case "7":
          return "오입금";
          break;
      }
    },
  },
  data() {
    return {
      actives: 0,
      paginationTotal: 0,
      paginationPer: 10,
      pagination: {
        currentPage: 1,
      },
      csList: [],
    };
  },
};
</script>
<style></style>
